import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import React from 'react';
import { connect } from 'react-redux';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from '@redux-saga/core';
import TemplatePageContainer from '~/containers/TemplatePageContainer';
import { saveLoadedSearchContent } from '~/containers/TemplatePageContainer/actions';
import { loadProfile } from '~/containers/AuthProvider/actions';
import {
  invalidKeywords,
  MAX_LENGTH_OF_SEARCH_KEYWORD,
  USER_ROLES,
} from '~/config';
import cookies from '~/services/cookies';
import { templateService, categoryService } from '~/services';
import { wrapper } from '~/store';
import withi18next from '~/hocs/withi18next';
import withAutoLogin from '~/hocs/withAutoLogin';
import { redirectWithoutSSOToken } from '~/utils/mainHelpers/redirectWithoutSSOToken';

@withi18next()
@withAutoLogin()
class SearchTemplates extends React.Component {
  state = {
    dataSource: [],
    isSearching: false,
  };
  async componentDidMount() {
    const { i18n, userProfile, loadProfile, categoryTemplates } = this.props;
    loadProfile(userProfile);
    this.setState({ isSearching: true });
    let langTemplate = i18n.language === 'ja' ? 'jp' : i18n.language;
    const dataSource = categoryTemplates.templates.map((cat) => ({
      id: cat.id,
      name: JSON.parse(cat.name)[`cat_name_${langTemplate}`],
    }));
    this.setState({ dataSource, isSearching: false });

    if (process.browser) {
      if (userProfile.role === USER_ROLES.USER) {
        redirectWithoutSSOToken();
        // const currentURL = window.location.href;
        // if (currentURL.includes('?ssoToken')) {
        //   window.history.pushState(
        //     '',
        //     '',
        //     `${currentURL.split('?ssoToken')[0]}`,
        //   );
        // }
      }
    }
  }

  render() {
    const { isSearching, dataSource } = this.state;
    const { keyword, query } = this.props;

    return (
      <TemplatePageContainer
        type="search"
        keyword={keyword}
        dataSource={dataSource}
        isSearching={isSearching}
        query={query}
      />
    );
  }
}

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async ({ locale, query, req }) => {
    let userProfile;
    let userInfor = cookies.get('userInfo', req);
    if (userInfor) {
      userInfor = JSON.parse(userInfor);
    }
    if (!userInfor) {
      userInfor = query.userInfo;
    }

    userProfile = {
      role: query.role || USER_ROLES.USER,
      subType: query.subType || '',
      isAuthenticated: userInfor ? userInfor.isAuthenticated : false,
      userInfor: userInfor || null,
    };
    store.dispatch(loadProfile(userProfile));

    const categoryTemplates = await categoryService.listTemplateCategories({
      role: query.role || USER_ROLES.USER,
    });

    let searchKeyword = '';
    if (query.keyword) {
      searchKeyword = query.keyword;
    }

    const isInvalidKeywords = invalidKeywords.some((k) =>
      searchKeyword.toLowerCase().includes(k.toLowerCase()),
    );
    if (
      isInvalidKeywords ||
      searchKeyword.length >= MAX_LENGTH_OF_SEARCH_KEYWORD
    ) {
      return {
        props: {
          ...(await serverSideTranslations(locale, ['common'])),
          categoryTemplates,
          userProfile,
          query,
          keyword: searchKeyword,
          lang: locale,
          page: query.page || 1,
          role: query.role || USER_ROLES.USER,
        },
      };
    }

    const data = await templateService.searchTemplates({
      keyword: searchKeyword,
      page: query.page || 1,
      role: query.role || USER_ROLES.USER,
    });
    if (data.collection) {
      data.collection.forEach((item) => {
        if (item.title) {
          try {
            item.titles = JSON.parse(item.title);
            item.title = item.titles['title_original'] || '';
          } catch (err) {
            item.titles = item.title;
            item.title = '';
          }
        } else {
          item.title = '';
        }
      });
    }
    store.dispatch(
      saveLoadedSearchContent(
        data.collection,
        data.total_item,
        parseInt(data.page),
        data.total_page,
      ),
    );

    // If using async saga, end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    return {
      props: {
        ...(await serverSideTranslations(locale, ['common'])),
        userProfile,
        query,
        categoryTemplates,
        keyword: searchKeyword,
        lang: locale,
        page: query.page || 1,
        role: query.role || USER_ROLES.USER,
      },
    };
  },
);

const mapDispatchToProps = (dispatch) => ({
  loadProfile: (profile) => dispatch(loadProfile(profile)),
  saveLoadedSearchContent: (collection, total_item, page, total_page) =>
    dispatch(saveLoadedSearchContent(collection, total_item, page, total_page)),
});

export default connect(null, mapDispatchToProps)(SearchTemplates);
